export const REALTIME_CONNECTION_STATES = Object.freeze({
  CONNECTING: "CONNECTING",
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
});

export const NOTIFICATION_INBOX_CHANGE_SOURCES = Object.freeze({
  LOCAL_MUTATION: "LOCAL_MUTATION",
});

let realtimeConnectionState = REALTIME_CONNECTION_STATES.CONNECTING;
const realtimeListeners = new Set();
const inboxListeners = new Set();

function notifyListeners(listeners, value) {
  for (const listener of listeners) {
    try {
      listener(value);
    } catch {
      // A view recovery callback must never interrupt the shared transport.
    }
  }
}

export function getRealtimeConnectionState() {
  return realtimeConnectionState;
}

export function setRealtimeConnectionState(nextState) {
  if (!Object.values(REALTIME_CONNECTION_STATES).includes(nextState)) return;
  if (realtimeConnectionState === nextState) return;
  realtimeConnectionState = nextState;
  notifyListeners(realtimeListeners, nextState);
}

export function subscribeRealtimeConnectionState(listener) {
  realtimeListeners.add(listener);
  return () => realtimeListeners.delete(listener);
}

export function notifyNotificationInboxChanged(source) {
  notifyListeners(inboxListeners, source);
}

export function subscribeNotificationInboxChanged(listener) {
  inboxListeners.add(listener);
  return () => inboxListeners.delete(listener);
}
